import { render, staticRenderFns } from "./CombinePromoteModal.vue?vue&type=template&id=b86c3d00&scoped=true&"
import script from "./CombinePromoteModal.vue?vue&type=script&lang=js&"
export * from "./CombinePromoteModal.vue?vue&type=script&lang=js&"
import style0 from "./CombinePromoteModal.vue?vue&type=style&index=0&id=b86c3d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c3d00",
  null
  
)

export default component.exports